import BaseModel from './base';

export default class RootModalModel extends BaseModel {
	constructor(initData) {
		super();

		this.id = '';
		this.className = '';
		this.isOpen = false;
		this.isShowLoader = false;
		this.title = '';
		this.headerIcon = null;
		// one of ['withdrawal', 'receiving']
		this.tag = '';
		this.outsideParams = {};
		this.nestedModal = null;
		this.isBackdropClickOrEscape = true;
		this.isShowCloseIcon = true;
		this.headerIconDisabled = false;
		this.isHideHeader = false;
		this.type = 'default';
		this.closeCustomHandler = null;

		this.height = null;
		this.fullScreenBase = false;

		this.headerContent = null; // можно передать как стрингу(тогда просто тайтл будет) так и компонент тогда кастомный хидер будер
		this.headerBackground = null; // если кастомный компонент то передать фон чтобы передался и в хидер
		this.leftButtons = [{icon: null, iconSize: null, onClick: null}]; // массив кнопок {icon, onClick}
		this.buttonStyles = {color: null, background: null}  // стили для кнопок
		this.isHeaderWithColorBgAndIcon = false;
		this.subtitle = '';
		this.headerIcon = null;
		this.headerBackgroundColor = 'white';

		this.copyFrom(initData);
	}
}
